import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from '@openng/optimus-ui/table';
import { FlairrStatsRoutingModule } from './flairr-stats-routing.module';
import { FlairrStatsComponent } from './flairr-stats.component';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '@shared';

@NgModule({
  imports: [CommonModule, FlairrStatsRoutingModule, TableModule, BrowserModule, SharedModule],
  declarations: [FlairrStatsComponent],
})
export class FlairrStatsModule {}
